import LocalStorageAlternative from './alternative.storage'

class AppStorage {
  
  constructor ( key, useSeesionStorage = false )  {
    this.key = key
    try {
      this.storage = ( useSeesionStorage ) ? window.sessionStorage : window.localStorage
    } catch ( err ) {
      this.storage = new LocalStorageAlternative()
    }
  }

  setValue ( value ) {
    this.storage.setItem( this.key, value )
  }

  getValue () {
    return this.storage.getItem( this.key )
  }

  deleteValue () {
    this.storage.removeItem( this.key )
  }
}

export {
  AppStorage
}


// WEBPACK FOOTER //
// ./src/storage/app.storage.js